/**
 * common defines
 */

// export type Listener = (messages: Array<any>) => void;
